import { render, staticRenderFns } from "./park-backAndWhite-rule.vue?vue&type=template&id=dad2bf2c&"
import script from "./park-backAndWhite-rule.vue?vue&type=script&lang=js&"
export * from "./park-backAndWhite-rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports